export default "__VITE_ASSET__DZJKevFs__"